<template>

<component-module moduleName="logbooks">
    <template v-slot:programName>Log Books</template>
    <template v-slot:navigation>
        <div class="main-nav">
            <template v-for="(menuItem, index) in sort0">
                <div v-if="menuItem.not_allowed" class="not-allowed" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</div>
                <router-link v-else class="link" :to="(menuItem.link_type == 'LEGACY' ? '/legacy/' : '') + menuItem.link_value" :key="'sub_menu_item_' + menuItem.menu_item_id">{{ menuItem.menu_label }}</router-link>
            </template>
        </div>
        <div class="secondary-nav">
            <div class="secondary-nav-title"><i class="fas fa-book"></i> Your Logbooks</div>
			<div v-if="getLogbooks.length > 0 && !getLoadingModule" v-for="logbook in getLogbooks">
                <router-link class="link" :to="{ path: '/logbooks/list', query: { log_books: logbook.ffl_log_book_id } }">{{ logbook.description }}</router-link>
                <div class="two-columns" style="margin: 0 0 0.5em 1em;">
    				<router-link class="link" :to="{ path: '/logbooks/list', query: { on_hand: 1, log_books: logbook.ffl_log_book_id } }">On Hand</router-link>
    				<router-link class="link" :to="{ path: '/logbooks/list', query: { disposed: 1, log_books: logbook.ffl_log_book_id } }">Disposed</router-link>
                </div>
			</div>
        </div>
    </template>
    <template v-slot:settings>
        <div class="secondary-nav">
            <div class="secondary-nav-title"><i class="fas fa-cog"></i> Settings</div>
            <template v-for="(menuItem, index) in sort1">
                <div v-if="menuItem.not_allowed" class="not-allowed" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</div>
                <router-link v-else class="link" :to="(menuItem.link_type == 'LEGACY' ? '/legacy/' : '') + menuItem.link_value" :key="'sub_menu_item_' + menuItem.menu_item_id">{{ menuItem.menu_label }}</router-link>
            </template>
            <router-link class="link" to="/logbooks/enable-feature?paperless=1">Enable Paperless Storage</router-link>
            <router-link class="link" to="/logbooks/enable-feature?signonscreen=1">Enable Sign On Screen</router-link>
			<div class="checkbox-group" style="padding: 0.25em 0;">
				<span :class="['pointer', 'far', includeUPCs ? 'fa-check-square' : 'fa-square']" @click="updateIncludeUPCs()"></span>
				<label class="bold">Include UPCs in export</label>
			</div>
            <div style="margin: 1em 0 0 0;">
                <router-link class="link" to="/logbooks/4473-v2">Previous 4473 Program</router-link>
            </div>
            
        </div>
    </template>
</component-module>

</template>

<script>
import styles from './logbooks.scss'
import { mapState, mapActions } from 'vuex'
export default {
    data() {
    	return {
            includeUPCs: 'false',
            clientHasVariance: false,
            signOnScreenEnabled: false
        }
    },
    created() {
        this.updateCustomModuleName('Log Books');
    },
    mounted() {
        if (this.getUser.user_name && this.$route.path.indexOf('customer-4473') == -1) {
    		this.apiCall({ destination: 'get_item_preference', data: { preference_code: 'INCLUDE_UPCS_IN_LOGBOOK_EXPORT,ELECTRONIC_STORAGE_VARIANCE,ENABLE_SCREEN_CAPTURE_SIGNATURE' } }).then(obj => {
    			this.includeUPCs = obj.INCLUDE_UPCS_IN_LOGBOOK_EXPORT
                this.clientHasVariance = obj.ELECTRONIC_STORAGE_VARIANCE
                this.signOnScreenEnabled = obj.ENABLE_SCREEN_CAPTURE_SIGNATURE
    		}).catch(err => {
    			console.log(err)
    		})
        }
    },
    computed: {
        ...mapState({
            getOpenDropdown: (state, getters) => getters.getOpenDropdown,
            getLoadingModule: (state, getters) => getters['logbooks/getLoadingModule'],
            getLogbooks: (state, getters) => getters['logbooks/getLogbooks']
        }),
        sort0() {
            if (!this.getModuleNavMenu) return {}
            if (!this.getModuleNavMenu.sort_0) return {}
            return this.getModuleNavMenu.sort_0.menu_items
        },
        sort1() {
            if (!this.getModuleNavMenu) return {}
            if (!this.getModuleNavMenu.sort_1) return {}
            return this.getModuleNavMenu.sort_1.menu_items
        }
    },
	methods: {
        ...mapActions([
            'updateOpenDropdown'
        ]),
        updateIncludeUPCs() {
            this.includeUPCs = !this.includeUPCs
    		this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'INCLUDE_UPCS_IN_LOGBOOK_EXPORT', value: this.includeUPCs } }).then(obj => {
    			if (obj.status == 'success') {
                    //this.includeUPCs = obj.INCLUDE_UPCS_IN_LOGBOOK_EXPORT
    			}
    		}).catch(err => {
    			console.log(err)
    		})
        }
    }
}
</script>
